import React, { ReactNode } from 'react';
import { SelectOption } from 'global';
import { Stack, Typography } from '@mui/material';
import { Control } from 'react-hook-form/dist/types/form';
import { InputField, SelectField } from 'components/form/rhf';

import { CustomerFormValues } from './customerFormSchema';

interface Props {
  title?: string;
  icon?: ReactNode;
  country: string;
  regions: SelectOption[];
  countries: SelectOption[];
  control: Control<CustomerFormValues>;
  prefix: 'billingAddress' | 'deliveryAddress';
}

export const AddressFields = ({ control, prefix, title, icon, countries, regions, country }: Props) => {
  const isUS = country === 'US';

  return (
    <Stack gap="0.75rem">
      {title && (
        <Stack direction="row" gap="0.5rem" alignItems="center">
          {icon}

          <Typography variant="subtitle2" component="span">
            {title}
          </Typography>
        </Stack>
      )}

      <SelectField
        label="Country"
        control={control}
        variant="outlined"
        options={countries}
        name={`${prefix}.country`}
      />

      <InputField
        control={control}
        label="Street Address"
        name={`${prefix}.streetAddress`}
        inputProps={{
          variant: 'outlined',
        }}
      />

      <InputField
        label="City"
        control={control}
        name={`${prefix}.city`}
        inputProps={{
          variant: 'outlined',
        }}
      />

      <Stack direction="row" gap="1rem">
        <SelectField
          label={isUS ? 'State' : 'Province'}
          control={control}
          variant="outlined"
          options={regions}
          name={`${prefix}.state`}
        />

        <InputField
          control={control}
          label={isUS ? 'ZIP Code' : 'Postal Code'}
          name={`${prefix}.zip`}
          inputProps={{
            variant: 'outlined',
          }}
        />
      </Stack>
    </Stack>
  );
};
